const textFieldPalette = (tokens) => {
    return {
        radius: tokens.textfieldRadius,
        padding: tokens.textfieldPadding,
        spaceBetween: tokens.textfieldSpaceBetween,
        font: {
            family: tokens.textfieldFontFamily,
            size: tokens.textfieldFontSize,
            lineHeight: tokens.textfieldLineHeight,
            weight: tokens.textfieldFontWeight,
            letterSpacing: tokens.textfieldLetterSpacing
        },
        background: {
            default: tokens.textfieldColorBgDefault,
            hover: tokens.textfieldColorBgHover,
            focus: tokens.textfieldColorBgFocus,
            disabled: tokens.textfieldColorBgDisabled,
            error: tokens.textfieldColorBgError
        },
        border: {
            width: tokens.textfieldBorderWidth,
            default: tokens.textfieldColorBorderDefault,
            hover: tokens.textfieldColorBorderHover,
            focus: tokens.textfieldColorBorderFocus,
            disabled: tokens.textfieldColorBorderDisabled,
            error: tokens.textfieldColorBorderError
        },
        helpText: {
            font: {
                family: tokens.helpTextFontFamily,
                size: tokens.helpTextFontSize,
                weight: tokens.helpTextFontWeight,
                lineHeight: tokens.helpTextLineHeight,
                letterSpacing: tokens.helpTextLetterSpacing
            },
            text: {
                default: tokens.textfieldColorTextHelperTextDefault,
                disabled: tokens.textfieldColorTextHelperTextDisabled,
                error: tokens.textfieldColorTextHelperTextError
            }
        },
        label: {
            text: {
                default: tokens.textfieldColorTextLabelDefault,
                disabled: tokens.textfieldColorTextLabelDisabled,
                error: tokens.textfieldColorTextLabelError
            }
        },
        placeholder: {
            text: {
                default: tokens.textfieldColorTextPlaceholderDefault,
                disabled: tokens.textfieldColorTextPlaceholderDisabled
            }
        },
        textEntered: {
            text: {
                default: tokens.textfieldColorTextEnteredDefault,
                disabled: tokens.textfieldColorTextEnteredDisabled
            }
        }
    };
};
export default textFieldPalette;
//# sourceMappingURL=textField.js.map